import { useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { fetchOrders, selectOrders } from "store/vino/ordersSlice";
import OrderList from "./OrderList";

const Orders = () => {
	const dispatch = useDispatch();
	const orders = useSelector(selectOrders);

	useEffect(() => {
		dispatch(fetchOrders());
	}, [dispatch]);

	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	return (
		<div className="flex flex-col flex-auto flex-shrink-0 w-full">
			<div className="flex flex-col flex-1 max-w-2xl w-full mx-auto px-8 sm:px-16">
				<motion.div
					className="flex flex-wrap"
					variants={container}
					initial="hidden"
					animate="show"
				>
					<OrderList orders={orders} />
				</motion.div>
			</div>
		</div>
	);
};

export default Orders;
